import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from 'src/app/core/base/base.component';
import { SecurityOptionProfileView } from 'src/app/model/security/option-profile';

@Component({
  selector: 'ms-khuyana-header-submenu',
  templateUrl: './khuyana-header-submenu.component.html',
  styles: [
    `
      :host {
        width: 100%;
      }
      .header__menu-list {
        margin-left: 20px;
      }
    `,
  ],
})
export class KhuyanaHeaderSubmenuComponent extends BaseComponent {
  @Input() menuOption: SecurityOptionProfileView = {};
  @Input() class = '';
  @Output() selected = new EventEmitter<boolean>();
  @Output() leave = new EventEmitter<boolean>();

  constructor() {
    super();
  }

  override onDestroy = () => this.selected.emit(false);

  onItemClick = () => this.selected.emit(!this.menuOption.isSelected);

  onLinkClick = () => this.leave.emit(true);

  onKeyEnter = ($ev: KeyboardEvent) => {
    const keyCode = $ev.code.toLowerCase();
    if (keyCode === 'enter' || keyCode === 'space') {
      this.onItemClick();
    }
  };
}
